<ul class="product-list" [ngClass]="{'product-list-paper': variant === 'paper', 'product-list-dividers': dividers}"><ng-content></ng-content></ul>
